<template>
  <div class="receiving-orders">
    <el-dialog :visible.sync="determinePrintersFirst" width="30%">
      <div class="d-block text-center">
        <div class="text-center">
          <img
            style="width: 90px; margin-bottom: 10px"
            src="@/assets/printer.svg"
            alt=""
          />
        </div>
        <h3 class="text-center">من فضلك حدد الطابعات علي الجهاز اولاً</h3>
      </div>
    </el-dialog>

    <div class="container-fluid">
      
      <div class="show-orders" v-if="!showDeliveryModel">
        <!-- <h6 class="text-right" style="color: #949494;font-size: 12px;">ابحث برقم الهاتف و المناطق و رقم الطلب</h6> -->

        <div class="filter-orders d-flex mb-4">
          <div class="ml-5">
              <h6
                  style="
                    font-size: 20px;
                    padding-top: 5px;
                    font-family: 'CairoBold';
                    cursor: pointer;
                        color: #fe5634 !important;

                  "
                >  
               <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Capa_1"
            enable-background="new 0 0 512 512"
               width="40"
                  height="40"
                  viewBox="-34 0 511 511.999"
                   
          >
            <g>
              <path
                d="m484.827 157.974h-86.825c-14.983 0-27.173 12.196-27.173 27.188v99.934h-32.476c1.805-6.561 2.474-14.3 2.035-23.306v-.001c-.705-38.059-7.611-70.135-20.528-95.337-10.03-19.567-21.735-31.298-31.779-38.311 11.789-12.121 18.605-29.364 18.605-49.251 0-35.781-28.543-64.89-63.626-64.89s-63.626 29.109-63.626 64.89c0 4.143 3.358 7.5 7.5 7.5h5.096c-.469 2.83-.719 5.714-.719 8.643 0 25.216 18.018 46.291 41.84 51.014-2.497 9.272-3.738 20.205-3.733 32.625l-18.706 16.089-45.515 3.681-52.503-17.356c-4.812-1.6-10.266-3.408-14.998.004-4.663 3.365-4.663 9.256-4.663 11.191v39.035c0 4.143 3.358 7.5 7.5 7.5h8.929l-13.695 47.324c-1.151 3.978 1.141 8.138 5.12 9.289 3.981 1.157 8.138-1.141 9.29-5.119l14.902-51.494h21.322c-26.52 80.872-11.388 134.854 11.871 189.485h-13.482l-56.153-62.786 11.874-41.02c1.152-3.979-1.14-8.138-5.119-9.289s-8.138 1.141-9.29 5.119l-11.357 39.237c-35.126-.586-66.546 23.632-74.553 58.475-.927 4.036 1.592 8.06 5.627 8.988l10.647 2.45c-2.72 28.252 15.885 54.907 44.259 61.438 4.309.993 8.655 1.483 12.971 1.483 10.644 0 21.101-2.984 30.35-8.781 10.855-6.802 18.943-16.802 23.32-28.62l8.401 1.933c2.503.579 4.877.872 7.249-.405 2.207-1.188 3.674-3.333 4.224-5.754.528-2.455.93-4.95 1.209-7.468h156.858c5.016 31.187 31.551 54.696 63.242 54.696s58.227-23.509 63.243-54.696h5.724s1.136.013 1.395.013c2.145 0 5.243-.238 7.787-2.826 1.273-1.295 2.767-3.612 2.652-7.293-.211-7.043-1.268-13.848-3.072-20.316 5.974-36.268.226-58.357-8.295-75.644 5.387-3.531 8.959-9.615 8.959-16.527v-20.613h37.883c14.983 0 27.173-12.196 27.173-27.188v-87.746c.002-14.991-12.187-27.187-27.171-27.187zm-388.746 312.933c-9.601 6.017-20.961 7.93-31.989 5.391h-.001c-20.298-4.672-33.84-23.285-32.853-43.411l81.353 18.724c-3.366 7.925-9.061 14.628-16.51 19.296zm37.528-29.866-116.665-26.846c9.003-24.654 33.231-40.974 59.714-39.57l57.151 63.901c-.05.843-.116 1.681-.2 2.515zm113.285-130.695c-2.177 5.742-2.177 12.821-2.177 22.62v28.302h-27.463v-38.828c0-43.898 23.958-51.721 34.71-53.012h73.529c-.296 9.963-2.544 17.045-6.812 21.54-4.974 5.238-13.485 7.79-26.021 7.802l-26.921.028c-9.6.001-15.94 3.885-18.845 11.548zm-2.177 65.921v17.908c-.068 0-.138 0-.21 0h-53.273c.599-5.554 2.329-9.852 5.17-12.826 4.226-4.422 10.178-5.082 13.35-5.082zm80.445-121.838h-68.207c-2.739-8.619-5.181-18.057-7.189-27.757l20.737-13.46c11.32-7.351 17.209-17.738 16.157-28.499-.932-9.539-7.417-18.06-16.521-21.707-8.314-3.33-17.263-2.284-25.172 2.773.652-7.174 1.866-13.578 3.622-19.014 3.197-.33 6.372-.955 9.49-1.872 6.347-1.474 12.212-3.823 17.507-6.938 14.445 8.63 46.215 36.622 49.576 116.474zm-130.179-183.038c3.537-23.964 23.749-42.39 48.077-42.39 26.812 0 48.626 22.381 48.626 49.89 0 22.374-10.729 40.407-28.029 48.343v-39.463c0-6.833-2.615-15.215-15.069-16.349-.226-.021-.453-.031-.68-.031zm11.329 23.643c0-2.96.337-5.851 1-8.643h40.228c.463.05.801.104 1.043.153.039.278.073.678.073 1.227v43.876c-1.787.263-3.585.396-5.382.397-.017 0-.034 0-.05 0-20.356-.019-36.912-16.614-36.912-37.01zm-9.723 115.92 17.764-1.437c1.583-.127 3.084-.754 4.289-1.789l32.06-27.575.005-.005c3.1-2.671 6.409-4.041 9.631-4.041 1.434 0 2.851.272 4.224.822 3.963 1.587 6.777 5.215 7.171 9.241.495 5.067-2.843 10.203-9.396 14.459l-35.725 23.188h-30.021v-12.863zm-31.696 2.564 16.696-1.35v11.651h-19.401c-2.515 0-3.128-2.09-3.2-3.843-.041-.994.053-5.978 5.905-6.458zm-17.751-5.178c-2.259 3.704-3.314 8.037-3.141 12.25.045 1.091.184 2.142.378 3.166 0 .021-.012.042-.008.062h-36.336v-28.473l39.136 12.937c-.012.02-.018.039-.029.058zm15.088 30.478h66.601c1.449 0 2.868-.42 4.083-1.209l3.395-2.204c1.633 7.218 3.493 14.242 5.519 20.876-15.296 4.515-39.575 19.106-39.575 66.158v39.581c-5.262 1.062-11.487 3.516-16.694 8.965-5.489 5.744-8.624 13.527-9.376 23.189h-15.13c-15.246-43.938-21.044-90.694 1.177-155.356zm12.362 189.458c-2.772-6.375-5.444-12.726-7.96-19.101h77.874c10.093 0 15.21-4.595 15.21-13.656v-26.752-28.302h59.199c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-59.145c.096-4.26.369-7.744 1.15-9.802.379-1.001.707-1.865 4.826-1.865l26.928-.028c16.865-.016 28.93-4.096 36.885-12.474.368-.388.716-.795 1.065-1.2h47.706 53.615v20.613c0 2.578-2.173 4.756-4.745 4.756h-74.665c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h70.258c5.928 11.003 11.26 24.694 10.943 46.325-14.838-20.611-38.859-33.864-66.121-33.864-21.894 0-42.438 8.588-57.849 24.183-13.675 13.837-21.888 31.796-23.578 51.192zm193.958 54.723c-23.446 0-43.22-16.893-48.004-39.696h96.008c-4.785 22.801-24.559 39.696-48.004 39.696zm56.524-54.696h-113.046-10.775c3.682-33.913 32.038-60.377 66.362-60.377 30.135 0 55.442 19.871 63.823 47.688.027.088.054.176.084.263 1.185 3.991 2.022 8.145 2.475 12.426zm71.926-155.395c0 6.721-5.461 12.188-12.173 12.188h-98.998v-38.731h111.171zm0-41.543h-111.171v-15.951h111.171zm0-30.951h-111.171v-15.252c0-6.721 5.461-12.188 12.173-12.188h86.825c6.712 0 12.173 5.468 12.173 12.188z"
              />
            </g>
          </svg>
              تقرير التسليمات
             
         
            </h6>





            </div>

          <div class="ml-2">
            <el-input
              @keydown.enter.native="handleFilter()"
              placeholder="ابحث بالموبايل"
              v-model="mobile"
            >
            </el-input>
          </div>

          <div class="ml-2">
            <el-input
              @keydown.enter.native="handleFilter()"
              placeholder="ابحث برقم الطلب"
              v-model="code"
            ></el-input>
          </div>
          <div class="ml-2">
            <el-select
              clearable
              @change="handleFilter"
              v-model="area"
              placeholder="ابحث بالمناطق"
            >
              <!-- <el-option :key="5" label="5" :value="5"> </el-option> -->

              <el-option
                v-for="area in areas"
                :key="area.id"
                :label="area.name"
                :value="area.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="ml-2">
                <el-select
          @change="handleFilter"
  placeholder="حدد الكاشير"
                      v-model="user"
                      filterable
                      clearable
                      value-key="id"
                    >
                      <el-option
                        v-for="user in users"
                        :key="user.id"
                        :label="user.name"
                        :value="user.id"
                      >
                        {{ user.name }}
                      </el-option>
                    </el-select>
          </div>
         
        </div>
        <div>
          <!-- <div v-for="order in orders" :key="order.id" class="col-md-3">
            <div class="order-card">
              <div class="order-count">
                <el-tooltip content="عدد المنتجات لهذا الطلب" placement="top">
                  <el-button> {{ order.products.length }} </el-button>
                </el-tooltip>
              </div>

              <div class="customer-data">
                <span class="text-center"> تفاصيل الطلب</span>
                <table style="width: 100%">
                  <tr>
                    <td>رقم الطلب</td>
                    <td>{{ order.id }}</td>
                  </tr>
                  <tr>
                    <td>اسم العميل</td>
                    <td>
                      <span> <b>أ/</b> </span> {{ order.customer.name }}
                    </td>
                  </tr>
                  <tr>
                    <td>الموبايل</td>
                    <td>{{ order.customer.phone }}</td>
                  </tr>
                  <tr>
                    <td>رقم الهاتف</td>
                    <td>{{ order.customer.mobile }}</td>
                  </tr>
                  <tr>
                    <td>الحالة</td>
                    <td
                      style="border: none"
                      class="text-primary text-center"
                      v-if="order.status == 1"
                    >
                      في المطبخ
                    </td>
                    <td
                      style="border: none"
                      class="text-warning text-center"
                      v-if="order.status == 2"
                    >
                      في الطريق
                    </td>
                    <td
                      style="border: none"
                      class="text-success text-center"
                      v-if="order.status == 3"
                    >
                      تم التوصيل
                    </td>
                    <td
                      style="border: none"
                      class="text-danger text-center"
                      v-if="order.status == 4"
                    >
                      تم الرفض
                    </td>
                  </tr>
                  <tr>
                    <td>العنوان</td>
                    <td style="font-size: 12px">{{ order.address }}</td>
                  </tr>
               
                </table>

                <div class="mb-2 d-flex">
                  <vs-button
                    @click.native="showOrderProducts(order)"
                    transparent
                    class="mx-auto"
                  >
                    عرض المنتجات
                  </vs-button>
                  <vs-button
                    v-if="
                      selectedOrderType.id == 2 &&
                      order.employee &&
                      order.status == 2
                    "
                    transparent
                    @click.native="showDeliveryInfo(order)"
                    class="mx-auto"
                  >
                    السائق
                  </vs-button>
                </div>
              
              </div>

              <div class="buttons d-flex" v-if="order.status != 2">
                <div>
              
                  <el-button
                    :style="{
                      width: selectedOrderType.id != 2 ? '100%' : '90%',
                    }"
                    plain
                    @click="openModelToUpdateStatus(order)"
                    class="heven-custom"
                    type="primary"
                    >تغيير الحالة</el-button
                  >
                </div>

                <div v-if="selectedOrderType.id == 2">
                  <el-button
                    style="
                      background-color: #fe5634 !important;
                      border-color: #fe5634 !important;
                    "
                    color="#FE5634"
                    @click="openAssignToDeliveryModel(order)"
                    type="primary"
                  >
                    إسناد إلي سائق
                  </el-button>
               
                </div>
              </div>
            </div>
          </div> -->

          <el-table
            class="mt-2 infinite-list"
            align="right"
            v-if="orders.length > 0"
            :data="orders"
            border
            style="width: 100%; overflow: auto;"
            height="95vh"
            v-el-table-infinite-scroll="loadMoreData"
            :infinite-scroll-disabled="disabled"
            >
            <el-table-column label="#" type="index" width="50">
            </el-table-column>
            <el-table-column sortable width="100" label="رقم " prop="order">
            </el-table-column>

            <el-table-column width="100" label="القيمة">
              <template slot-scope="scope">
                <!-- {{ Number(scope.row.total) + Number(scope.row.restaurant_cost) +
                    Number(scope.row.driver_cost) -
                    Number(scope.row.discount) -
                    Number(scope.row.delivery_discount)
                }} -->

                {{ calcPrice(scope.row) }}
              </template>
            </el-table-column>
             <el-table-column sortable width="100" label="الخصم" prop="discount">
            </el-table-column>
            <el-table-column width="90" label="الحالة">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status == 1">في المطبخ</el-tag>
                <el-tag type="warning" v-if="scope.row.status == 2"
                  >في الطريق</el-tag
                >
                <el-tag type="success" v-if="scope.row.status == 3"
                  >تم التوصيل
                </el-tag>
                <el-tag type="danger" v-if="scope.row.status == 4">
                  ﻣﺮﻓﻮﺽ بعد</el-tag
                >
                <el-tag type="danger" v-if="scope.row.status == 5"
                  >ﻣﺮﻓﻮﺽ قبل</el-tag
                >
              </template>
            </el-table-column>

            <el-table-column  width="100" label="العميل" >

               <template slot-scope="scope" v-if="scope.row">
                <span v-if="scope.row.client_name">{{
                  scope.row.client_name
                }}</span>
                <span v-else>{{
                  scope.row.customer.name
                }}</span>
              </template>
            </el-table-column>
            <el-table-column width="120" label="الفون" prop="customer.mobile">
            </el-table-column>
            <el-table-column label="بواسطة">
              <template slot-scope="scope">
                {{
                  scope.row.from == "mobile"
                    ? "تطبيق الموبايل"
                    : scope.row.user && scope.row.user.name
                }}
              </template>
            </el-table-column>

            <el-table-column label="اﻟﺴﺎﺋﻖ">
              <template slot-scope="scope">
                <span v-if="scope.row.employee.id > 1">{{
                  scope.row.employee.name
                }}</span>
              </template>
            </el-table-column>

            <el-table-column width="160" sortable label="التوقيت">
              <template slot-scope="scope">
                <span v-if="scope.row.order.created_at">
                  {{ $moment(scope.row.order.created_at).format("lll") }}
                </span>
                <span v-if="scope.row.created_at" dir="ltr">
                  {{ scope.row.created_at | moment(" D/MM/YYYY | h:mm A") }}
                </span>
              </template>
            </el-table-column>
            <!-- <el-table-column width="0" sortable label="الاسناد">

              <template slot-scope="scope">
                <span v-if="scope.row.order.assigned_at"> {{ $moment(scope.row.order.assigned_at).format('lll') }} </span>
                    <span v-if="scope.row.assigned_at"> {{ $moment(scope.row.assigned_at).format('LLLL') }} </span>
              </template>
            </el-table-column> -->

            <el-table-column label="اجراءات" width="120">
              <template slot-scope="scope">
                <el-dropdown>
                  <el-button type="primary">
                    الإجرائات<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      @click.native="openModelToUpdateStatus(scope.row)"
                      v-if="
                        scope.row.status < 3 &&
                        scope.row.order_type_id != 2 &&
                        scope.row.area_id == 1
                      "
                      >تم الإستلام
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="scope.row.status < 3 && scope.row.area_id > 1"
                      @click.native="openAssignToDeliveryModel(scope.row)"
                      >إسناد إلي سائق</el-dropdown-item
                    >
                    <el-dropdown-item
                      v-if="scope.row.status < 3 && scope.row.area_id > 1"
                      @click.native="resetOrder(scope.row)"
                    >
                      إلغاء السائق</el-dropdown-item
                    >

                    <!-- <el-dropdown-item @click.native="printOrder(scope.row)" v-if="scope.row.printed === 0"> الطباعة
                    </el-dropdown-item> -->
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
            <el-table-column type="expand">
              <template slot-scope="props">
                <div class="row">
                  <div class="col-8">
                    <el-table
                      class="mt-2"
                      align="right"
                      :data="props.row.products"
                      border
                      style="width: 100%"
                    >
                      <el-table-column label="#" type="index" width="50">
                      </el-table-column>
                      <el-table-column
                        sortable
                        width="100"
                        label="الكمية "
                        prop="pivot.qty"
                      >
                      </el-table-column>
                      <el-table-column
                        label="الصنف "
                        prop="name"
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        label="المقاس "
                        prop="pivot.size"
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        label="السعر "
                        prop="pivot.price"
                      ></el-table-column>
                      <el-table-column width="100" label="الاجمالي">
                        <template slot-scope="scope">
                          <span>{{
                            scope.row.pivot.qty * scope.row.pivot.price
                          }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="col-4">
                    <div class="row pr-2 mt-2" style="text-align: start">
                      <div class="col-4" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0">الاجمالى</p>
                      </div>
                      <div class="col-8" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0px">
                          {{ props.row.total }}
                        </p>
                      </div>
                    </div>
                    <div class="row pr-2" style="text-align: start">
                      <div class="col-4" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0">خصم </p>
                      </div>
                      <div class="col-8" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0px">
                          {{ props.row.discount }}
                        </p>
                      </div>
                    </div>

                    <div class="row pr-2" style="text-align: start">
                      <div class="col-4" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0">سعر السائق</p>
                      </div>
                      <div class="col-8" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0px">
                          {{ props.row.driver_cost }}
                        </p>
                      </div>
                    </div>
                    <div class="row pr-2" style="text-align: start">
                      <div class="col-4" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0">سعر هيفن</p>
                      </div>
                      <div class="col-8" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0px">
                          {{ props.row.restaurant_cost }}
                        </p>
                      </div>
                    </div>

                    <div class="row pr-2" style="text-align: start">
                      <div class="col-4" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0">خصم توصيل</p>
                      </div>
                      <div class="col-8" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0px">
                          {{ props.row.delivery_discount }}
                        </p>
                      </div>
                    </div>

                    <div
                      class="row pr-2"
                      style="text-align: start"
                      v-if="props.row.point_discount"
                    >
                      <div class="col-4" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0">خصم النقاط</p>
                      </div>
                      <div class="col-8" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0px">
                          {{ props.row.point_discount }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="row pr-2"
                      style="text-align: start"
                      v-if="props.row.promocode_discount"
                    >
                      <div class="col-4" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0">خصم البروموكود</p>
                      </div>
                      <div class="col-8" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0px">
                          {{ props.row.promocode_discount }}
                        </p>
                      </div>
                    </div>
                    <div class="row pr-2" style="text-align: start">
                      <div class="col-4" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0">اسم العميل</p>
                      </div>
                      <div class="col-8" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0px" v-if="props.row.client_name">
                          {{ props.row.client_name }}
                          
                        </p>
                        <p style="margin: 10px 0px" v-else>
                          {{ props.row.customer.name }}
                          
                        </p>
                      </div>
                    </div>
                    <div class="row pr-2" style="text-align: start">
                      <div class="col-4" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0">رقم العميل</p>
                      </div>
                      <div class="col-8" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0px">
                          {{ props.row.customer.mobile }}
                        </p>
                      </div>
                    </div>
                    <div class="row pr-2" style="text-align: start">
                      <div class="col-4" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0">العنوان</p>
                      </div>
                      <div class="col-8" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0px">{{ props.row.address }}</p>
                      </div>
                    </div>
                    <div
                      class="row pr-2"
                      style="text-align: start"
                      v-if="props.row.notes"
                    >
                      <div class="col-4" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0">* ﻣﻼﺣﻈﺎﺕ</p>
                      </div>
                      <div class="col-8" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0px">
                          {{ props.row.notes }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="row pr-2"
                      style="text-align: start"
                      v-if="props.row.rejected_reason"
                    >
                      <div class="col-4" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0">* ﻣﻼﺣﻈﺎﺕ</p>
                      </div>
                      <div class="col-8" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0px">
                          {{ props.row.rejected_reason }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="row pr-2"
                      style="text-align: start"
                      v-if="
                        props.row.payment_type && props.row.payment_type == 1
                      "
                    >
                      <div class="col-4" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0">نوع الدفع</p>
                      </div>
                      <div class="col-8" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0px">نقدي</p>
                      </div>
                    </div>
                    <div
                      class="row pr-2"
                      style="text-align: start"
                      v-if="
                        props.row.payment_type && props.row.payment_type == 2
                      "
                    >
                      <div class="col-4" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0">نوع الدفع</p>
                      </div>
                      <div class="col-8" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0px">فيزا</p>
                      </div>
                    </div>
                     <div
                        class="row pr-2"
                        style="text-align: start"
                        v-if="
                          props.row.payment_type && props.row.payment_type == 3
                        "
                      >
                        <div class="col-4" style="border: 1px solid #ebeef5">
                          <p style="margin: 10px 0">نوع الدفع</p>
                        </div>
                        <div class="col-8" style="border: 1px solid #ebeef5">
                          <p style="margin: 10px 0px">انستا</p>
                        </div>
                      </div>
                      <div
                        class="row pr-2"
                        style="text-align: start"
                        v-if="
                          props.row.payment_type && props.row.payment_type == 4
                        "
                      >
                        <div class="col-4" style="border: 1px solid #ebeef5">
                          <p style="margin: 10px 0">نوع الدفع</p>
                        </div>
                        <div class="col-8" style="border: 1px solid #ebeef5">
                          <p style="margin: 10px 0px"> فودافون كاش</p>
                        </div>
                      </div>
                    <div
                      class="row pr-2"
                      style="text-align: start"
                      v-if="props.row.preparated_at"
                    >
                      <div class="col-4" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0">تاريخ الاستلام</p>
                      </div>
                      <div class="col-8" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0px">
                          {{
                            new Date(props.row.preparated_at).toLocaleString(
                              "ar-EG"
                            )
                          }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="row pr-2"
                      style="text-align: start"
                      v-if="props.row.assigned_at"
                    >
                      <div class="col-4" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0">تاريخ الاسناد</p>
                      </div>
                      <div class="col-8" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0px">
                          {{
                            new Date(props.row.assigned_at).toLocaleString(
                              "ar-EG"
                            )
                          }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="row pr-2"
                      style="text-align: start"
                      v-if="props.row.rejected_reason"
                    >
                      <div class="col-4" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0">سبب الرفض</p>
                      </div>
                      <div class="col-8" style="border: 1px solid #ebeef5">
                        <p style="margin: 10px 0px">
                          {{ props.row.rejected_reason }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <el-row class="mt-2 mb-2" v-if="pagination.current_page < pagination.last_page && pagination.last_page > 1">
          <el-col>
            <el-button style="width: 100%;" class="d-block" type="danger" @click="loadMoreData">تحميل المزيد</el-button>
          </el-col>
        </el-row> -->
      </div>

      <div class="show-deliveries" v-if="showDeliveryModel">
        <el-button
          class="d-block heven-secondary p-0"
          icon="el-icon-right"
          plain
          @click="showDeliveryModel = !showDeliveryModel"
          type="primary"
          >الرجوع إلي الطلبات</el-button
        >

        <div class="deliveries mt-3">
         <!-- <h6 class="text-right" style="color: #949494; font-size: 12px">
            ابحث بأسم العميل و رقم الهاتف و التليفون و المناطق
          </h6>-->
          <div class="d-flex">
            <div class="ml-2">
              <el-input
                @keydown.enter.native="getDrivers()"
                placeholder="ابحث بأسم السائق "
                v-model="driverName"
              >
              </el-input>
            </div>
            <div class="ml-2">
              <el-input
                @keydown.enter.native="getDrivers()"
                placeholder="ابحث برقم السائق  "
                v-model="driverMobile"
              >
              </el-input>
            </div>
          </div>

          <div class="row">
            <div v-for="boy in drivers" :key="boy.id" class="col-md-2">
              <div
                class="delivery-boy"
                @click="setDeliveryBoy(boy)"
                :class="{
                  'selected-delivery-boy': boy.id == currDeliveryBoy.id,
                }"
              >
                <img src="@/images/delivery-boy.png" alt="" />
                <div>
                  <h6 style="font-size: 18px; margin-bottom: 10px">
                    {{ boy.name }}
                  </h6>
                  <h6>{{ boy.mobile }}</h6>
                  <!-- <div class="row">
                                        <div class="col-md-12">
                                            <h6> <b>الراتب / </b> {{boy.salary}} <sub>L.E</sub></h6>
                                        </div>
                                        <div class="col-md-12">
                                            <h6> <b>الساعه / </b> {{boy.hour_cost}} </h6>
                                        </div>
                                    </div> -->

                  <!-- <h6> {{boy.address}} </h6> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <vs-dialog v-model="toggleOrderProducts">
      <template #header>
        <h4 class="not-margin">منتجات الطلب</h4>
      </template>

      <div class="con-form">
        <div class="">
          <table class="custom-table">
            <thead>
              <tr>
                <td>المنتج</td>
                <td>الكمية</td>
                <td>السعر</td>
                <td>المقاس</td>
              </tr>
            </thead>

            <tr v-for="(item, index) in currOrderProducts" :key="index">
              <td>{{ item.name }}</td>
              <td>{{ item.pivot.qty }}</td>
              <td>{{ item.pivot.price }}</td>
              <td>{{ item.pivot.size }}</td>
            </tr>
          </table>
        </div>
        <!-- <el-select v-model="updateStatus" placeholder="إختر الحالة">
                <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select> -->
      </div>

      <!-- <template #footer>

          <el-button style="background-color: #FE5634 !important;border-color: #FE5634 !important;color:#FFF !important" plain @click="updateStatusInBackend()" type="primary">
             تعديل الحالة

        </el-button>

        </template> -->
    </vs-dialog>

    <vs-dialog v-model="showModelToUpdateStatus">
      <template #header>
        <h4 class="not-margin">تعديل حالة الطلب</h4>
      </template>

      <div class="con-form">
        <!-- <el-select v-model="updateStatus" placeholder="إختر الحالة">
          <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        <h6>هل أنت متأكد انك تريد تغيير الحالة إلي تم التسليم ؟</h6>
      </div>

      <template #footer>
        <!-- <vs-button border @click="updateStatusInBackend()"> </vs-button> -->

        <el-button
          style="
            background-color: #fe5634 !important;
            border-color: #fe5634 !important;
            color: #fff !important;
          "
          plain
          @click="updateStatusInBackend()"
          type="primary"
        >
          تعديل الحالة
        </el-button>
      </template>
    </vs-dialog>

    <vs-dialog v-model="showDeliveryInfoModel">
      <template #header>
        <h4 class="not-margin">سائق هذا الطلب</h4>
      </template>

      <div class="con-form">
        <table class="custom-table">
          <thead>
            <tr>
              <td>الأسم</td>
              <td>الموبايل</td>
              <td>السعر</td>
              <td>تكلفة الساعة</td>
            </tr>
          </thead>

          <tr v-if="currOrder && currOrder.employee">
            <td>{{ currOrder.employee.name }}</td>
            <td>{{ currOrder.employee.mobile }}</td>
            <td>{{ currOrder.employee.salary }}</td>
            <td>{{ currOrder.employee.hour_cost }}</td>
          </tr>
        </table>
      </div>
    </vs-dialog>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
import Type from "@/components/Operations/Type.vue";
// import { ipcRenderer } from 'electron'

export default {
  components: {
    Type,
  },
  watch: {},
  computed: {
    noMore () {
      return this.pagination.current_page >= this.pagination.last_page;
    },
    disabled () {
      return this.loading || this.noMore
    },
  },
  data() {
    return {
        users: [],
    user:null,
      invoice_details:null,
      driverMobile: "",
      driverName: "",
      mobile: "",
      code: "",
      area: "",
      areas: [],
      printers: [],
      tableData: [],

      currOrder: [],
      toggleOrderProducts: false,
      currOrderProducts: [],
      currDeliveryBoy: {},
      drivers: [],
      updateStatus: "",
      showDeliveryModel: false,
      orders: [],
      statusOptions: [
        { label: "قيد الإنتظار", value: 1 },
        { label: "في الطريق", value: 2 },
        { label: "تم التوصيل", value: 3 },
        // { label: "تم الرفض", value: 4 },
      ],
      showModelToUpdateStatus: false,
      active: 0,
      selectedOrderType: {id:2},
      types: [],
      from: "",
      determinePrintersFirst: false,
      showDeliveryInfoModel: false,
      pagination: {
        current_page: 1,
        last_page: 1,
      },
      swiperOptionBestSeller: {
        slidesPerView: 8,
        spaceBetween: 5,
        slidesPerGroup: 1,
        loopFillGroupWithBlank: false,
        breakpoints: {
          1200: {
            slidesPerView: 8,
            spaceBetween: 5,
          },
          1024: {
            slidesPerView: 6,
            spaceBetween: 5,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 5,
          },
          350: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          0: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      startFilter: false,
      loading: false,
    };
  },

  created() {
    this.getOrderTypes(true);
    this.getDrivers();
    this.getAllAreas();
    this.getAllPrinters();
    this.getUsers();

  },

  methods: {
      getUsers() {
      const loading = this.$loading({
          lock: true,
          text: false,
          spinner: 'el-icon-loading',
          background: 'rgba(255,255,255,.7)',
          customClass: 'fullscreen-loading'
        });
      axiosApi.get(`/users`).then((res) => {
        this.users = res.data;
      }).finally(() => loading.close());
    },
    handleFilter() {
      this.startFilter = true;
      this.getTaslimatReport();
    },
    castDate(date) {
      return new Date(date).toLocaleString("ar-EG");
    },
    calcPrice(order) {
      const collectedItems =
        +order.total + +order.restaurant_cost + +order.driver_cost;
      const discountItems =
        +order.point_discount +
        +order.promocode_discount +
        +order.delivery_discount 
        +
        +order.discount
        ;
      return collectedItems - discountItems;
    },
    async printOrder(order) {
      let res = await axiosApi.post(`/print-order/${order.id}`);
      order.printed = res.data && res.data.printed;
      this.printInvoiceDetails({
        products: [...order.products],
        invoice: order,
        kitchenPrinters: true,
        sendPrinted: true,
      });
      this.$store.commit("SET_ORDERS", this.orders);
    },
    showDeliveryInfo(order) {
      this.currOrder = { ...order };
      this.showDeliveryInfoModel = true;
    },

    getAllAreas() {
      axiosApi.get(`/areas`).then((res) => {
        this.areas = res.data;
      });
    },
    showOrderProducts(order) {
      this.toggleOrderProducts = true;
      this.currOrderProducts = [...order.products];
    },
    printInvoiceDetails(products) {
      let productsCategories = [];
      for (let i = 0; i < products.length; i++) {
        productsCategories.push(products[i].product_category_id);
      }

      productsCategories = [...new Set(productsCategories)];

      let productsPrinters = [];
      productsCategories.map((ele2, index) => {
        productsPrinters.push([]);
        products.map((ele) => {
          if (ele.product_category_id == ele2) {
            productsPrinters[index].push(ele);
          }
        });
      });

      const { ipcRenderer } = require("electron");
      ipcRenderer.send("printOrder", products);
    },

    getAllPrinters() {
      if (JSON.parse(localStorage.getItem("printers"))) {
        let printers = JSON.parse(localStorage.getItem("printers"));

        if (printers.findIndex((ele) => !ele.devicePrinter) > -1) {
          this.printers = [];
          return;
        }
      }

      this.printers = JSON.parse(localStorage.getItem("printers"));
    },

    setDeliveryBoy(delivery) {
      if (!this.printers || this.printers.length == 0) {
        this.determinePrintersFirst = true;

        // setTimeout(() => {
        //   this.$bvModal.hide("determinePrintersFirst");
        // }, 2000);

        return;
      }

      this.currDeliveryBoy = { ...delivery };
      axiosApi
        .put(`/orders/${this.currOrder.id}`, {
          employee_id: this.currDeliveryBoy.id,
        })
        .then((res) => {
         this.invoice_details=res.data;
         this.printInvoice();
          this.$notify({
            title: "تم بنجاح",
            message: "تم إسناد السائق إلي الطلب بنجاح",
            type: "success",
          });
          this.showDeliveryModel = false;
          this.startFilter = true;
          this.getTaslimatReport();
        });
    },
    printInvoice(){
      // ! send invoice to print
      //  this.invoice_details[0].created_at=this.$moment(this.invoice_details[0].created_at).tz('Asia/Riyadh').format('YYYY-MM-DD hh:mm A');
     this.invoice_details[0].products.map((product)=>{
        console.log("p",product)
        product['price']=parseFloat(product['pivot']["price"])
        product['qty']=parseFloat(product["pivot"]["qty"])
        product["total"]=parseFloat(product['pivot']["price"]) * parseFloat(product["pivot"]["qty"])
      })
      let data={
         "printerName": this.printers[0].devicePrinter,
        invoice:this.invoice_details[0],
          CompanyName:"",
          showLogo:true,
        notes:"notes",
        showLogo:true,
        CompanyName:"الـكـتـكـوت",
      
      }
      axiosApi
        .post(
          `http://localhost:16881/api/PrintMainInvoice`,data
        )

        .then((response) => {
         console.log('printed')
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getDrivers() {
      let url = `/employees/drivers?page=1`;
      if (this.driverMobile.trim() != "") {
        url += "&mobile=" + this.driverMobile;
      }
      if (this.driverName.trim() != "") {
        url += "&name=" + this.driverName;
      }

      axiosApi.get(url).then((res) => {
        this.drivers = res.data.data;
      });
    },
    openAssignToDeliveryModel(order) {
      this.showDeliveryModel = true;
      this.currOrder = { ...order };
    },
    updateStatusInBackend() {
      this.showModelToUpdateStatus = false;
      const loading = this.$vs.loading();
      axiosApi
        .put(`/orders/${this.currOrder.id}/status`, {
          status: 3,
        })
        .then(() => {
          this.$notify({
            title: "تم بنجاح",
            message: "تم تحديث حالة الطلب بنجاح",
            type: "success",
          });
          this.getTaslimatReport();
        })
        .finally(() => loading.close());
    },
    resetOrder(order) {
      this.showModelToUpdateStatus = false;
      const loading = this.$vs.loading();
      // orders-reset/{id}
      axiosApi
        .post(`/orders-reset/${order.id}`)
        .then(() => {
          this.$notify({
            title: "تم بنجاح",
            message: "تم تحديث حالة الطلب بنجاح",
            type: "success",
          });
          this.getTaslimatReport();
        })
        .finally(() => loading.close());
    },
    openModelToUpdateStatus(order) {
      this.currOrder = { ...order };
      this.updateStatus = this.currOrder.status;
      this.showModelToUpdateStatus = true;
    },
    selectType(type) {
      this.startFilter = true;
      this.selectedOrderType = { ...type };
      this.getTaslimatReport();
    },
    getTaslimatReport() {
      if (this.startFilter) {
        this.pagination = {
          current_page: 1,
          last_page: 1,
        }
        this.tableData = [];
        this.orders = [];
      }
      const loading = this.$vs.loading();
      let url = `/taslimat?page=${this.pagination.current_page}`;
      if (this.mobile.trim() != "") {
        url += "&mobile=" + this.mobile;
      }
      if (this.code.trim() != "") {
        url += "&code=" + this.code;
      }
      if (this.area != "") {
        url += "&area=" + this.area;
      }
       if (this.user >0) {
        url += "&user=" + this.user ;
      }
      if (this.from != "") {
        url += "&from=" + this.from;
      }
      axiosApi
        .get(url)
        .then((res) => {
          this.pagination.current_page = res.data.current_page;
          this.pagination.last_page = res.data.last_page;
          if (this.orders.length > 0) {
            this.orders = [...this.orders, ...res.data.data];
            this.$store.commit("SET_ORDERS", this.orders);
            this.tableData = [...this.tableData, ...res.data.data];
          } else {
            this.orders = res.data.data;
            this.$store.commit("SET_ORDERS", res.data.data);
            this.tableData = res.data.data;
          }
        })
        .finally(() => {
          this.startFilter = false;
          loading.close()
          this.loading = false;
        });
    },
    loadMoreData() {
      this.loading = true;
      if (this.pagination.last_page > this.pagination.current_page) {
        this.pagination.current_page++;
        this.getTaslimatReport();
      }
    },
    getOrderTypes(inCreated = false) {
      const loading = this.$vs.loading();
      let x = axiosApi
        .get("order-types")
        .then((res) => {
          this.types = res.data;
        })
        .finally(() => loading.close());
      if (inCreated) {
        Promise.all([x]).then(() => {
          this.selectedOrderType = this.types[0];
          this.getTaslimatReport();
        });
      }
    },
  },
};
</script>

<style lang="scss">
.con-form {
  .el-select {
    width: 100%;
    margin-bottom: 14px;
  }
}

.el-select-dropdown.el-popper {
  z-index: 999999 !important;
}

.selected-type {
  background: #fe5634 !important;
  color: #fff !important;
}

.selected-delivery-boy {
  background: #f7f7f7 !important;
}

.receiving-orders {
  margin-top: 20px;
}

.receiving-orders {
  .swiper-slide {
    width: auto !important;
  }

  .deliveries {
    .delivery-boy {
      cursor: pointer;
      padding: 25px 0;
      // box-shadow: 0 4px 25px 0 #0000000f;
      border-radius: 17px;
      margin-top: 15px;
      text-align: center !important;

      img {
        width: 67px;
      }

      h6 {
        font-size: 12px;
        margin-bottom: 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.show-orders {
  padding: 0 40px !important;

  .order-card {
    position: relative;
    box-shadow: 0 4px 25px 0 #0000000f;
    padding: 6px 7px;
    margin-bottom: 15px;
    text-align: start;
    height: 322px;

    .order-count {
      button {
        padding: 8px 10px 5px;
        border: 1px solid #eee;
        border-radius: 50%;
      }

      position: absolute;
      top: 11px;
      right: 10px;
    }

    .customer-data {
      table {
        font-family: din;
        //    margin-bottom:10px;
      }

      table,
      tr,
      td {
        //    border: 1px solid #333;
        padding: 3px;
      }

      td {
        &:last-of-type {
          text-align: center;
          padding: 0 9px;
          font-size: 14px;
        }

        &:first-of-type {
          width: 33%;
        }
      }

      > span {
        display: block;
        background: #ebf9fc;
        padding: 8px;
        margin-bottom: 4px;
        /* border-bottom: 1px solid #ccc; */
        color: #545352;
      }

      h6 {
        margin-bottom: 4px;
      }

      .additional-data {
        h6 {
          font-size: 10px;
          color: #675d5d;
          margin-bottom: 6px;
        }
      }

      .total-price {
        b {
          font-size: 20px;
        }
      }
    }

    .buttons {
      div {
        flex: 1;
        text-align: center;

        button {
          width: 90%;
          margin: 0;
        }
      }
    }
  }
}

.el-button--primary.is-plain {
  color: #fe5634 !important;
  background: #ffffff !important;
  border-color: #fe5634 !important;
  transition: all 0.5s ease;

  &:hover {
    background: #fe5634 !important;
    color: #fff !important;
  }
}

.custom-table {
  width: 100%;
  direction: rtl;
  font-family: "din";

  thead {
    font-family: "din-bold";
  }

  td {
    font-size: 13px;
  }

  tr {
    &:nth-of-type(even) {
      background: #f7f7f7;
    }
  }
}
</style>
